// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"e7bfd581","23":"f4761f8e","835":"f4761f8e"}[chunkId] + ".chunk.css";
};